import { ORGANIZATIONS_KEY } from '@/atoms/organizations.atom';
import FullPageLoader from '@/components/FullPageLoader';
import { buildAppUrl } from '@/core/domain';
import { getToken, removeToken } from '@/core/token';
import posthog from 'posthog-js';
import { useEffect } from 'react';

export default function LogoutPage() {
  useEffect(() => {
    posthog.reset();
    fetch(`${import.meta.env.VITE_ENDPOINT}/logout`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }).finally(() => {
      localStorage.removeItem(ORGANIZATIONS_KEY);
      removeToken();
      window.location.href = buildAppUrl('/auth/login');
    });
  }, []);

  return <FullPageLoader title='Loading...' subtitle='Please wait while we log you out...' />;
}
